class CCHomepage {
  constructor(root) {
    if (!root || root.dataset.ccReady === 'true') return;
    root.dataset.ccReady = 'true';
    this.root = root;
    this.filters = Array.from(root.querySelectorAll('[data-cc-filter]'));
    this.cards = Array.from(root.querySelectorAll('[data-cc-product]'));
    this.filters.forEach((button) => button.addEventListener('click', () => this.filter(button)));
  }

  filter(button) {
    const selected = button.dataset.ccFilter || 'all';
    this.filters.forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
    });
    this.cards.forEach((card) => {
      const groups = (card.dataset.ccProduct || '').split(' ');
      card.hidden = selected !== 'all' && !groups.includes(selected);
    });
  }
}

function initCCHomepages(scope = document) {
  scope.querySelectorAll('[data-cc-homepage]').forEach((root) => new CCHomepage(root));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCCHomepages());
} else {
  initCCHomepages();
}

document.addEventListener('shopify:section:load', (event) => initCCHomepages(event.target));
